import { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { OpportunityRefreshContext } from '../features/opportunities/OpportunityRefresh'

export function useApi<T>(loader: () => Promise<T>, dependencies: unknown[] = []) {
  const scope = useContext(OpportunityRefreshContext)
  const requestVersion = useRef(0)
  const [data, setData] = useState<T | null>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const reload = useCallback(async () => {
    const version = ++requestVersion.current
    setLoading(true)
    setError(null)
    try {
      const result = await loader()
      if (version === requestVersion.current) setData(result)
    } catch (caught) {
      if (version === requestVersion.current) setError(caught instanceof Error ? caught.message : 'Something went wrong. Please try again.')
    } finally {
      if (version === requestVersion.current) setLoading(false)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies)

  useEffect(() => {
    const unregister = scope?.register(reload)
    void reload()
    return () => { unregister?.(); requestVersion.current++ }
  }, [reload, scope])
  return { data, loading: loading && (!scope || data === null), refreshing: loading && data !== null, error, reload: scope?.refresh ?? reload, setData }
}
